import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { OptionLicense } from '../../models/option-licence.model';
import { TenantLicense } from '../../models/tenant-license.model';
import { UserLicense } from '../../models/user-licence.model';
import { UserLicenceService } from '../../services/user-licence.service';

@Component({
  selector: 'iw-options-users',
  templateUrl: './iw-options-users.component.html',
})
export class IwOptionsUsersComponent implements OnInit {
  @Input()
  public tenantLicense?: TenantLicense;
  @Input()
  public optionsList?: OptionLicense[];
  @Output()
  public errorMessage: EventEmitter<UserLicense[]> = new EventEmitter<
    UserLicense[]
  >();
  constructor(
    public readonly userLicenseService: UserLicenceService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {}

  public ngOnInit(): void {}

  public deleteUser(user: UserLicense): any {
    this.confirmationService.confirm({
      // tslint:disable-next-line: max-line-length
      message: this.translate.instant('Do you really want to delete this user login?'),
      header: this.translate.instant('Confirmation'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.userLicenseService.deleteUser(user.id).subscribe();
        if (this.tenantLicense) {
          // tslint:disable-next-line: max-line-length
          this.tenantLicense.registeredLicenseUsers = this.tenantLicense
            .registeredLicenseUsers
            ? this.tenantLicense.registeredLicenseUsers.filter(
                (u: UserLicense) => u !== user,
              )
            : undefined;
        }
        this.errorMessage.emit(this.tenantLicense?.registeredLicenseUsers);
      },
      reject: () => {
        return;
      },
    });
  }
}
